import axios from 'axios';
import { format } from 'date-fns';

import type { Environment, PTUpcomingScheduleSlot } from '../interfaces';
import type { NextPT } from '../interfaces/next-pt';
import type {
  PlatformTourReminder,
  PlatformTours,
} from '../interfaces/platform-tours';
import { hostsConfig } from '../utils/hosts-config';

export default abstract class PlatformTourDao {
  static async getReservationByContactIdAndLanguage(
    env: Environment,
    contactId: string,
    language: string
  ) {
    const url = hostsConfig[env].profileServiceUrl;

    const { data } = await axios.get<NextPT>(
      `${url}/v1/platform-tour-reservation/${contactId}/${language}`
    );

    return data;
  }

  static async getUpcomingPlatformTours(
    env: Environment,
    language: string,
    fromDate: Date,
    toDate: Date
  ) {
    const url = hostsConfig[env].liveclassServiceUrl;
    const formattedFromDate = format(fromDate, 'MMddyyyy');
    const formattedToDate = format(toDate, 'MMddyyyy');
    const { data } = await axios.get<PTUpcomingScheduleSlot[]>(
      `${url}/platform-tours/upcoming?language=${language}&fromDate=${formattedFromDate}&toDate=${formattedToDate}`
    );

    return data;
  }

  static async getNextPlatformTour(env: Environment, language: string) {
    const url = hostsConfig[env].liveclassServiceUrl;

    const { data } = await axios.get<PlatformTours>(
      `${url}/platform-tours/next?language=${language}`
    );

    return data;
  }

  static async savePlatformTourReminder(
    env: Environment,
    body: PlatformTourReminder
  ) {
    const url = hostsConfig[env].profileServiceUrl;

    const { data } = await axios.post<void>(
      `${url}/v1/platform-tour-reservation`,
      body
    );
    return data;
  }
}
